<template>
  <div>
    <ParagraphBody>
      Great! A new device is ready.
    </ParagraphBody>
    <ParagraphBody>
      {{ subheader }}
    </ParagraphBody>
    <InstallerNotes
      v-if="showInstallerNotes"
      :class="$style.notes"
    />
  </div>
</template>

<script>
import { ParagraphBody } from '@jumpcloud/ui-components';
import InstallerNotes from 'client/systems/InstallerNotes.vue';

export default {
  name: 'DeviceSetupSuccess',

  components: {
    InstallerNotes,
    ParagraphBody,
  },

  props: {
    showInstallerNotes: {
      type: Boolean,
      default: false,
    },

    subheader: {
      type: String,
      default: 'It may take one or two minutes to see the system in your Admin console.',
    },
  },
};
</script>

<style module scoped>
.notes {
  padding: var(--jc-spacer-large) 0;
}
</style>
